import React from 'react'
import CourseDetailSection from '../components/Details/CourseDetailSection'
import NavBar from '../components/Navbar/NavBar'
import Footer from '../components/Footer/Footer'





function CourseDetail() {
    
  return (
    <div>
          <NavBar/>
        <CourseDetailSection/>
        <Footer/>
    </div>
  )
}

export default CourseDetail